<!--  -->
<template>
  <v-layout max-width max-height class="flex-column overflow-auto">
    <div class="sms-settings__box flex-row align-center">
      <label>是否开启短信提醒功能：</label>
      <v-switch v-model="isOpen" @change="handleChange" />
    </div>
    <div class="sms-settings__box sms-settings__history">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="search.pageSize"
        disable-sort
        hide-default-footer
        item-key="id"
        class="pb-5 px-4 max-width overflow-auto header-grey"
        no-data-text="暂无查询数据"
        :loading="loading"
      >
        <template v-slot:item.status="{ item }">
          <div>
            <div>
              <a-tag :color="item.status === '发送成功' ? 'green' : 'red'">
                <a-icon
                  v-if="item.status === '发送成功'"
                  type="check"
                  :style="{ color: 'green' }"
                />
                <a-icon v-else type="close" :style="{ color: 'red' }" />
                {{ item.status }}
              </a-tag>
            </div>
            <div v-if="item.status !== '发送成功'">
              {{ item.reason }}
            </div>
          </div>
        </template>
      </v-data-table>
      <div class="mt-2 pr-2 mb-5 max-width flex-justify-end">
        <pagination
          v-model="search.pageNo"
          :size="search.pageSize"
          :total="total"
          @input="getList"
          @changePageSize="changePageSize"
        />
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'SmsSettings',
  components: {},
  data() {
    return {
      headers: [
        {
          text: '触发操作',
          value: 'operName',
        },
        {
          text: '收件人',
          value: 'receiveNames',
        },
        {
          text: '手机号',
          value: 'phone',
        },
        {
          text: '发送时间',
          value: 'createTime',
        },
        {
          text: '接收时间',
          value: 'receiveTime',
        },
        {
          text: '发送状态',
          value: 'status',
        },
      ],
      items: [],
      isOpen: false,
      search: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      loading: false,
    };
  },
  mounted() {
    this.$http.get(this.$api.smsSettingsGetIsOpen).then((res) => {
      this.isOpen = res.result.SYSTEM_OPEN_SMS === '1';
    });
    this.getList();
  },
  methods: {
    handleChange(val) {
      this.$http
        .post(this.$api.smsSettingsIsOpen, {
          data: {
            value: val ? '1' : '0',
          },
        })
        .then((res) => {});
    },
    getList() {
      this.loading = true;

      this.$http
        .get(this.$api.smsSettingsLogPage, {
          data: {
            pageNo: this.search.pageNo,
            pageSize: this.search.pageSize,
          },
        })
        .then((res) => {
          this.items = res.result.records;
          this.total = res.result.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePageSize(e) {
      console.log(e);
      this.search.pageSize = e;
      this.search.pageNo = 1;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-settings__box {
  background: #fff;
  border-radius: 8px;
  padding: 0 20px;
  margin-bottom: 20px;
}
.sms-settings__history {
  padding: 20px 0;
}
</style>
